module.exports = __webpack_public_path__ + "static/media/SWSCRC6-16.59974ae0.mp3";